import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
// import { createSelector } from "reselect"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import logo from "assets/images/logo.svg"
import { loginUser } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { useTranslation } from "react-i18next"
import Cookies from "js-cookie"

const Login = props => {
  const { t } = useTranslation()
  //meta title
  document.title = t("Login | Namq")

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [rememberMe, setRememberMe] = useState(false)

  useEffect(() => {
    const rememberedEmail = Cookies.get("rememberedEmail")
    const rememberedPassword = Cookies.get("rememberedPassword")
    if (rememberedEmail) {
      validation.setFieldValue("email", rememberedEmail)
      validation.setFieldValue("password", rememberedPassword)
      setRememberMe(true)
    } else {
      setRememberMe(false)
    }
  }, [])

  const handleRememberMeChange = e => {
    setRememberMe(!rememberMe)
    if (!rememberMe) {
      Cookies.remove("rememberedEmail")
      Cookies.remove("rememberedPassword")
    }
  }

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: values => {
      if (rememberMe) {
        Cookies.set("rememberedEmail", values.email, { expires: 30 })
        Cookies.set("rememberedPassword", values.password, { expires: 30 })
      } else {
        Cookies.remove("rememberedEmail")
        Cookies.remove("rememberedPassword")
      }

      // dispatch(loginUser(values, props.router.navigate));
      dispatch(loginUser({ ...values, history: props.router.navigate }))
        .then(action => {
          const { statusCode, status, msg, data } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
            const { uuid } = data
            if (uuid) {
              navigate(`/reset-password/${uuid}`)
            }
          }
        })
        .catch(error => {})
    },
  })

  const { loading } = useSelector(state => state.Login)

  return (
    <React.Fragment>
      <div className="account-pages">
        <Container
          style={{ display: "flex", alignItems: "center", height: "100%" }}
        >
          <Row className="justify-content-center login_form">
            <Col md={12}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-12">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Welcome Back !")}</h5>
                        <p>{t("Sign in to continue to Namq.")}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">{t("Email")}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder={t("Email")}
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">{t("Password")}</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder={t("Password")}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div
                        className="form-check"
                        onClick={handleRememberMeChange}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                          checked={rememberMe}
                          // onChange={handleRememberMeChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                          onClick={e => {
                            e.preventDefault()
                            handleRememberMeChange(e)
                          }}
                        >
                          {t("Remember me")}
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {t("Log In")}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          {t("Forgot your password?")}
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
